import React, { useState } from "react";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IXeroCreateInvoiceDTO from "../../../models/DTO/IXeroCreateInvoiceDTO";
import INotification from "../../../models/INotification";
import OwButton from "../OwButton/OwButton";
import OwDateInput from "../OwDateInput/OwDateInput";
import OwLabel from "../OwLabel/OwLabel";
import OwTitle from "../OwTitle/OwTitle";
import moment, { Moment } from "moment-timezone";
import { Socket } from "socket.io-client";

type Props = {
    createFn: (payload: Partial<IXeroCreateInvoiceDTO>) => void;
    cancelFn: (refreshData?: boolean) => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
};

export const OrderXeroInvoiceSetup: React.FC<Props> = (props) => {
    const [createActive, setCreateActive] = useState(false);
    // default due date 30 days out... (initial setup)
    const [dueDate, setDueDate] = useState<Date>(moment().add(30, "days").toDate());

    const cancel = () => {
        props.cancelFn(false);
    };

    const create = () => {
        if (dueDate) {
            const payload: Partial<IXeroCreateInvoiceDTO> = {
                dueDate: moment(dueDate).format("YYYY-MM-DD"),
            };

            props.createFn(payload);
        }
    };

    const handleDueDate = (date: Moment) => {
        setDueDate(date.toDate());
    };

    return (
        <div className={"OrderXeroInvoiceSetup p-2"}>
            <div className={"col-12 d-flex justify-content-between align-items-center"}>
                <OwTitle title={"create_invoice"} tag={"h3"} />
                <div className="text-end">
                    <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={cancel} />
                </div>
            </div>

            <hr />

            <div className={""}>
                <div>
                    <div>
                        <OwLabel title={"due_date"} showIsReqAsterik={true} />
                    </div>
                    <div>
                        <OwDateInput fn={handleDueDate} selectedDate={dueDate} />{" "}
                    </div>
                </div>
            </div>

            <div>
                <OwButton title={"create"} fn={create} active={createActive} disableOnActive={true} />
            </div>
        </div>
    );
};
